module.exports = __webpack_public_path__ + "../../browserconfig.xml";


// WEBPACK FOOTER //
// ./~/file-loader/!./src/_assets/img/browserconfig.xml